import React from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';

import PropTypes from 'prop-types';
import AbEnvironment from '../auth/AbEnvironment';

import withStyles from '@mui/styles/withStyles';
import { Button, CircularProgress, FormControl, FormControlLabel, Grid, InputLabel,
         Paper, Radio, RadioGroup, Snackbar, SnackbarContent, TextField, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import AppBindStyles from '../../AppBindStyles';
import SavingSpinner from '../ui/SavingSpinner';

import LoadingSpinner from '../ui/LoadingSpinner';
import ServerError from '../ui/ServerError';

import AccountUsersFetch from './AccountUsersFetch';
import classNames from 'classnames';


const abEnvironment = new AbEnvironment();
const StepEmailContactQuery = graphql`
query StepEmailContactQuery($accountId: UUID!) {
  accountTByAccountId(accountId: $accountId) {
    accountId
    parentId
    accountType
    accountNum
    accountName
    description
    contactLastName
    contactFirstName
    contactEmail
    contactPhone
    address1
    address2
    city
    state
    country
    postalCode
    accountStatus
    customerStatus
    useBudgets
    initialBalanceAmount
    autoTopupAmount
    autoTopupThreshhold
    maxMonthlyBudget
    rAutoTopupAmount
    rAutoTopupThreshold
    rMaxMonthlyBudget
    preApproveSubs
    rPreApproveSubs
    customerAppTsByCustomerAccountId {
      totalCount
      nodes {
        paymentOrder
        rPaymentOrder
        rPassThroughFees
        rAppMarkupPercentage
        bindCardTByBcId {
          bcStatus
        }
        pwd
      }
    }
    customerServiceTsByCustomerAccountId {
      totalCount
      nodes {
        soEntered
        soAccepted
        serviceStatus
      }
    }
    accountTByParentId {
      accountStatus
      useBudgets
      appTsByAccountId {
        nodes {
          appId
          appName
        }
      }
    }
  }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(3),
    textAlign: 'left',
    // maxWidth: 980
  },
  button: {
    width: 52,
  },
  error: {
    backgroundColor: theme.palette.error.light,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
});

class StepEmailContact extends React.Component {
  
  state = {
    usersLoaded: false,
    users: null,
    userSelected: null,
    createNewUser: false,
    userName: '',
    userRole: 1,
    lastName: null,
    firstName: null,
    email: null,
    phone: null,
    address1: null,
    address2: null,
    city: null,
    state: null,
    country: null,
    postalCode: null,

    saveStatus: null,
    saveMessage: null,
    snackbarOpen: false,
    snackbarDuration: null,
  }

  componentDidMount() {
    let acctId = this.props.customer.accountId;
    let contact = null;

    AccountUsersFetch.fetch(acctId).toPromise()
    .then(auf => {

      let theAccount = auf.accountTByAccountId;
      let existingUsers = []
      if (auf.accountTByAccountId.userTsByAccountId.totalCount > 0) {                  

        let users = auf.accountTByAccountId.userTsByAccountId.nodes;
        for (let i = 0; i < users.length; i++) {
          let user = JSON.parse(JSON.stringify( users[i]));
          if (user.email === theAccount.contactEmail ) {
            user.contact = true;
            user.selected = 1;
            contact = user;
          }
          existingUsers.push(user);
        }

        if (existingUsers.length > 0) {
          existingUsers.sort(function(a, b) {
            if(a.lastName < b.lastName) { return -1; }
            if(a.lastName > b.lastName) { return 1; }
            return 0;
          });
        }
      }
      if (contact === null) {
        //if no primary contact user, default to first user in list
        if (existingUsers.length > 0) {
          contact = existingUsers[0];
        }
      }

      this.setState({usersLoaded: true, userSelected: contact, users: existingUsers, lastName: theAccount.contactLastName, firstName: theAccount.contactFirstName, email: theAccount.contactEmail});

      if (contact) {
          this.props.setUserStateChanged(contact);
      }

    })
    .catch(err => {
      //nothing to do....
    })
  }

  isBackDisabled() {
    if (this.props.activeStep === 0)
      return true;

    return false;
  }

  isNextDisabled() {
    if (this.props.activeStep === this.props.assignedStep) {
      
      if (this.state.createNewUser) {
        return this.disableUserSave();
      }
      return false;
      
    }
    return false;
  }

  handleSnackbarClose = (event, reason) => { 
    this.setState({ snackbarOpen: false, saveStatus: '', saveMessage: '' });
  };

  handleUserChange(event) {

    let userId = event.target.value;
    if (userId === '0') {
      //user wants to create a new user.
      this.setState( {createNewUser: true, userSelected: null, firstName: null, lastName: null, email: null} );
      return;
    }

    let userSelected = null;
    let i = 0;
    for (i = 0; i < this.state.users.length; i++) {
      let user = this.state.users[i];
      if (user.userId === userId) {
          userSelected = user;
      }
    }

    if (userSelected) {

      this.setState({saveDisabled: false, userSelected: userSelected, createNewUser: false});
      this.props.setUserStateChanged(userSelected);
    }
  
  }

  disableUserSave() {
    const { validateEmail } = this.props.auth;

    if (!this.state.email || !this.state.lastName || !this.state.firstName)
      return true;
    
    // Is email an email address?
    let emailOk = validateEmail(this.state.email);
    if (! emailOk)
      return true;

    return false;
  }

  handleNext() {
    //cannot validate since user not logged in or not trying to add new.
    this.props.handleNext();
  }

  getUserSelectedValue() {
    if (this.state.createNewUser === true) {
      return 0;
    } else {
      return this.state.userSelected.userId;
    }
  }

  render() {
    const { logError, validateEmail } = this.props.auth;
    const classes = this.props.classes;

    let displayOnly = false;
    if (this.props.activeStep > this.props.assignedStep) {
      displayOnly = true;
    }

    let acctId = this.props.customer.accountId;

    return (
      <QueryRenderer
        environment={abEnvironment.getEnvironment()}
        query={StepEmailContactQuery}
        variables={{accountId: acctId}}
        render={({error, props})=> {
          if (error) {
            logError(error.message);
            return (
              <ServerError/>
            );
          } else if (props) {

            if (!this.state.usersLoaded) {
              //componentDidMount not finished
              return (
                <div className={classes.root}>
                  <Grid container direction="column" justifyContent="center">
                    <Grid item>
                      <Grid container spacing={0} direction="row" justifyContent="center" className={classes.spinny}>
                        <Grid item>
                          <CircularProgress color="primary" size={75} thickness={2}/>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              );
            }

            let emailError = false;
            if (this.state.email != null && this.state.email !== '') {
              let emailOk = validateEmail(this.state.email);
              if (! emailOk) {
                emailError = true;
              }
            }                  

            let theAccount = props.accountTByAccountId;
            let accountType = theAccount.accountType;

            let allowNewUser = true;
            if (this.props.customer.customerStatus && this.props.customer.customerStatus === 2) {
              allowNewUser = false;
            }

            //
            // Determine if services were added
            //
            let servicesAdded = false;
            for (let i = 0; i < theAccount.customerServiceTsByCustomerAccountId.nodes.length; i++) {
              let service = theAccount.customerServiceTsByCustomerAccountId.nodes[i];
              //exclude cancelled subs
              if (service.serviceStatus === 0 && service.soAccepted === 0 ) {
                servicesAdded = true;
              }
            }

              // Need to determine if the budget has changed or services have been added.
            let budgetChanged = false;
            let budgetExists = false;
            if (theAccount.autoTopupAmount > 0) {
              budgetExists = true;
            }

            if (budgetExists === false && (theAccount.rAutoTopupAmount > 0 || theAccount.initialBalanceAmount > 0 || theAccount.rMaxMonthlyBudget > 0)) {
              budgetChanged = true;
            } else {
              if (theAccount.rAutoTopupAmount    !== theAccount.autoTopupAmount     ||
                  theAccount.rAutoTopupThreshold !== theAccount.autoTopupThreshhold ||
                  theAccount.rMaxMonthlyBudget   !== theAccount.maxMonthlyBudget       ) {
                budgetChanged = true;
              }
            }


            if (!displayOnly) {
              if (this.state.users && this.state.users.length > 0) {

                let counter = 1;

                return (
                  <Grid container spacing={1} >
                    {theAccount.preApproveSubs === 1 && budgetChanged === false && servicesAdded === false && 
                    <Grid item xs={12}>
                      <Typography>
                        You can send a notification to the approver, but will not require their action to activate the subscriptions
                      </Typography>
                    </Grid>
                    }
                    <Grid item xs={12}>
                      <Paper className={classes.paper}>
                      <FormControl component="fieldset" className={classes.formControl}>
                        <RadioGroup aria-label="emailTo" name="emailTo" value={this.getUserSelectedValue()} onChange={(e) => this.handleUserChange(e)}>

                        { this.state.users.map(n => {

                          return (<FormControlLabel  key={(counter++).toString()}
                              value={n.userId}
                              control={<Radio />} 
                              label={<Typography variant="body2"><b>{n.firstName + ' ' + n.lastName}</b> ({n.email})</Typography>}
                            />);
                          })}

                          {allowNewUser &&
                          <FormControlLabel  key={(counter++).toString()}
                              value={0}
                              control={<Radio />} 
                              label={<Typography variant="body2"><b>{'Create new user'}</b> </Typography>}
                              />
                          }

                        </RadioGroup>
                      </FormControl>
                      {this.state.createNewUser === true &&
                        <Grid container spacing={2} >
                        <Grid item xs={12} sm={6}>
                          <TextField data-recording-ignore="mask"
                            id="first-name" label="First name" 
                            value={this.state.firstName}
                            onChange={(e) => this.setState({ firstName: e.target.value })}
                            inputProps={{ maxLength: 32 }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField data-recording-ignore="mask"
                            id="last-name" label="Last name"
                            value={this.state.lastName}
                            onChange={(e) => this.setState({ lastName: e.target.value })}
                            inputProps={{ maxLength: 32 }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField data-recording-ignore="mask"
                            id="email" label="Email" 
                            error={emailError}
                            value={this.state.email}
                            onChange={(e) => this.setState({ email: e.target.value })}
                            inputProps={{ maxLength: 254 }}
                          />
                        </Grid>

                        <Snackbar
                          anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                          }}
                          open={this.state.snackbarOpen}
                          autoHideDuration={this.state.snackbarDuration}
                          onClose={this.handleSnackbarClose}
                        >
                          <SnackbarContent
                            className={classNames(classes.message, classes[this.state.saveStatus])}
                            onClose={this.handleSnackbarClose}
                            message={
                              <Typography variant="body1">
                                  {this.state.saveMessage}
                              </Typography>
                            }
                            action={[
                              <IconButton
                                key="close"
                                aria-label="Close"
                                color="inherit"
                                className={classes.close}
                                onClick={this.handleSnackbarClose}
                                size="large">
                                <CloseIcon />
                              </IconButton>
                            ]}
                          />
                        </Snackbar>
                      </Grid>}
                      </Paper>
                    </Grid>

                    {this.props.activeStep === this.props.assignedStep &&
                    <Grid item xs={12}>
                      <Button
                        disabled={this.isBackDisabled()}
                        color="primary" variant="outlined"
                        onClick={() => this.props.handleBack()}
                        style={AppBindStyles.bottomButton}>
                        Back
                      </Button>

                      {this.state.saveStatus !== 'saving' &&
                      <Button
                        color="primary" variant="contained"
                        disabled={this.isNextDisabled()}
                        onClick={() => { this.determineNextStep(acctId, accountType);}}
                        style={AppBindStyles.bottomButton}>
                          Next
                      </Button>
                      }
                      {this.state.saveStatus === 'saving' &&
                        <Button
                          color="primary" variant="contained"
                          style={AppBindStyles.bottomButton}>
                            <SavingSpinner/>
                        </Button>
                      }
                    </Grid>} 
                  </Grid>
                );
              } else {
                //no users exist
      
                return (
                  <Paper className={classes.paper}>
                    <Grid container spacing={2} >
                      <Grid item xs={12} sm={6}>
                        <TextField data-recording-ignore="mask"
                          id="first-name" label="First name" 
                          value={this.state.firstName}
                          onChange={(e) => this.setState({ firstName: e.target.value })}
                          inputProps={{ maxLength: 32 }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField data-recording-ignore="mask"
                          id="last-name" label="Last name"
                          value={this.state.lastName}
                          onChange={(e) => this.setState({ lastName: e.target.value })}
                          inputProps={{ maxLength: 32 }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField data-recording-ignore="mask"
                          id="email" label="Email" 
                          error={emailError}
                          value={this.state.email}
                          onChange={(e) => this.setState({ email: e.target.value })}
                          inputProps={{ maxLength: 254 }}
                        />
                      </Grid>

                      <Snackbar
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'center',
                        }}
                        open={this.state.snackbarOpen}
                        autoHideDuration={this.state.snackbarDuration}
                        onClose={this.handleSnackbarClose}
                      >
                        <SnackbarContent
                          className={classNames(classes.message, classes[this.state.saveStatus])}
                          onClose={this.handleSnackbarClose}
                          message={
                            <Typography variant="body1">
                                {this.state.saveMessage}
                            </Typography>
                          }
                          action={[
                            <IconButton
                              key="close"
                              aria-label="Close"
                              color="inherit"
                              className={classes.close}
                              onClick={this.handleSnackbarClose}
                              size="large">
                              <CloseIcon />
                            </IconButton>
                          ]}
                        />
                      </Snackbar>

                      {this.props.activeStep === this.props.assignedStep &&
                      <Grid item xs={12}>
                        <Button
                          disabled={this.isBackDisabled()}
                          color="primary" variant="outlined"
                          onClick={() => this.props.handleBack()}
                          style={AppBindStyles.bottomButton}>
                          Back
                        </Button>

                        {this.state.saveStatus !== 'saving' &&
                        <Button
                          color="primary" variant="contained"
                          disabled={this.disableUserSave()}
                          onClick={() => { this.createUser(acctId, accountType);}}
                          style={AppBindStyles.bottomButton}>
                            Next
                        </Button>
                        }

                        {this.state.saveStatus === 'saving' &&
                        <Button
                          color="primary" variant="contained"
                          style={AppBindStyles.bottomButton}>
                            <SavingSpinner/>
                        </Button>
                        }
                      </Grid>}
                    </Grid>
                  </Paper>
                );
              }
            } else {
              //display only
              return (
                <Grid container >
                  {theAccount.preApproveSubs === 1 && budgetChanged === false && servicesAdded === false && 
                  <Grid item xs={12} style={{marginBottom:8}}>
                    <Typography>
                      We'll send a notification to the approver, but will not require their action to activate the subscriptions
                    </Typography>
                  </Grid>}
                  <Grid item xs={12}>
                    <InputLabel shrink style={{marginBottom:6}}>Approver</InputLabel>
                    <Typography variant="body1" style={AppBindStyles.boldLabel}>
                      {this.props.customer.companyName}
                    </Typography>
                    <Typography variant="body2">
                      {this.props.user.firstName}&nbsp;{this.props.user.lastName}<br/>
                      {this.props.user.email}
                    </Typography>
                  </Grid>
                </Grid>
              );
        
            }
          }
          if (!displayOnly) {
            return <div><LoadingSpinner/></div>
          }
        }
      }
      />
    );

  }

  determineNextStep = (accountId, accountType) => {
    if (this.state.createNewUser) {
      this.createUser(accountId, accountType);
    } else {
      this.handleNext();
    }

  }

  createUser = (accountId, accountType) => {
    this.setState({ saveStatus: 'saving' });
    const { userRole,
            lastName, firstName, email, phone,
            address1, address2, city, state, country, postalCode } = this.state;
    const { callPartnerApi } = this.props.auth;

    let pAccountId = abEnvironment.getUserAttribute('a_id');
    let aPjwt = abEnvironment.getPjwt();
    let success = false;


    callPartnerApi('appbind/user',
                   'POST',
                   {
                    'pjwt':aPjwt,
                    'accountId': accountId,
                    'pAccountId': pAccountId,
                    'accountType': accountType,
                    'userRole': userRole,
                    'lastName': lastName,
                    'firstName': firstName,
                    'email': email,
                    'phone': phone,
                    'address1': address1,
                    'address2': address2,
                    'city': city,
                    'state': state,
                    'country': country,
                    'postalCode': postalCode
                   })
    .then((response) => {
      if (response.status === 200) {
        success = true;
      }
      return response.json();
      /*response.json().then(data => {
        // do something with your data
        console.log(data);
       let errorObj = {
        'error': { errMessage : data.errMessage }
        }
       throw(errorObj);
      });*/
      
    
      
    })
    .then((response) => {
      //console.log(JSON.stringify(response));
      if (success) {
        //set up a user object in memory
        //console.log(response);
        let user = {userId : response.abUserId,
                    lastName: lastName,
                    firstName: firstName,
                    email: email}
        //console.log(user);

        //put this new user in the list
        let existingUsers = this.state.users;

        existingUsers.push(user);

        if (existingUsers.length > 0) {
          existingUsers.sort(function(a, b) {
            if(a.lastName < b.lastName) { return -1; }
            if(a.lastName > b.lastName) { return 1; }
            return 0;
          });
        }

        this.setState({saveStatus: '', users: existingUsers, userSelected: user, firstName: null, lastName: null, email: null});

        this.props.setUserStateChanged(user);
        this.props.handleNext();
      } else {
        //sort of a hack to have this here.
        let theMessage = 'Unable to create user'
        if (response.errMessage != null)
        {
          theMessage = response.errMessage;
        }
        this.setState({ snackbarOpen: true, saveStatus: 'error', saveMessage: theMessage, saveSnackbarDuration: null });
      }
    })
    .catch(error => {
      let theMessage = 'Unable to create user'
      if (error.errMessage != null)
      {
        theMessage = error.errMessage;
      }
      this.setState({ snackbarOpen: true, saveStatus: 'error', saveMessage: theMessage, saveSnackbarDuration: null });
    });
  }


}


StepEmailContact.propTypes = {
  assignedStep: PropTypes.number.isRequired,
  activeStep: PropTypes.number.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired
};

export default withStyles(styleSheet)(StepEmailContact);
